import { Chip } from '@material-ui/core';

import { ReactComponent as BundleIcon } from 'assets/images/icons/multipleBag.svg';

import { orderTypeAsFlags } from './OrderTypeChip.util';
import { useOrderTypeChipTexts } from './useOrderTypeChipTexts';

import makeClasses from './OrderTypeChip.style';

import type { ChipProps } from '@material-ui/core';
import type { OrderType } from './OrderTypeChip.type';

export function OrderTypeChip(props: Props) {
  const { orderType, extraLabel = '', classes, ...overProps } = props;
  if (orderType === 'normal') return null;

  const text = useOrderTypeChipTexts({ orderType });

  const _classes = makeClasses();

  return (
    <Chip
      role='status'
      aria-live='polite'
      label={`${text} ${extraLabel}`.trim()}
      icon={<TheIcon orderType={orderType} />}
      classes={{
        root: _classes.root,
        icon: _classes.icon,
        label: _classes.label,
        ...classes,
      }}
      {...overProps}
    />
  );
}

function TheIcon({ orderType }: { orderType: OrderType }) {
  const { isBundle } = orderTypeAsFlags(orderType);
  return isBundle ? <BundleIcon /> : null;
}

interface Props extends ChipProps {
  orderType: OrderType;
  extraLabel?: string;
}
